<template>
  <div class="d-flex justify-content-between">
    <div class="CardTabs" :class="{noMargin, stretch}">
      <span
        v-for="tab in tabs"
        :key="tab.id"
        class="tab px-3"
        :class="{
          active: tab.id === selectedTab,
          error: tab.error,
          hasNumber: tab.number,
        }"
        :id="tab.id"
        @click="selectedTab = tab.id"
      >
        <svg
          v-if="tab.error"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="#DC2626"
        >
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd"
          />
        </svg>
        <slot v-else :name="`icon-${tab.id}`"></slot>

        {{ tab.name }}

        <span v-if="tab && tab.number" class="number">
          {{ tab.number }}
        </span>
      </span>
    </div>

    <div class="d-flex align-items-center">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noMargin: Boolean,
    stretch: Boolean,
    value: {
      type: String,
    },
    tabs: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      selectedTab: this.value,
    };
  },
  watch: {
    value(val) {
      this.selectedTab = val;
    },
    selectedTab(val) {
      this.$emit("input", val);
    },
  },
};
</script>

<style>
.CardTabs .tab svg {
  transform: translateY(-1.5px);
  color: #9a9a9a;
}
</style>

<style scoped>
.CardTabs {
  display: flex;
  transform: translateY(1.5px);
  position: relative;
  align-items: flex-end;
  overflow: auto;
  z-index: 10;
}

.CardTabs.stretch {
  align-items: stretch;
}

.tab {
  position: relative;
  white-space: nowrap;
  display: inline-block;
  transition-duration: 0.2s;
  cursor: pointer;

  border: 1px solid rgba(0, 0, 0, 0.125);
  font-size: 1.2em;
  border-bottom: 0px;
  border-radius: 1px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  background-color: #f6f6f6;

  padding-top: 8px;
  padding-bottom: 8px;
}

.stretch .tab {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.number {
  position: absolute;
  background-color: #0081c7;
  color: white;
  font-size: 0.75em;
  padding: 1px 6px;
  border-radius: 50px;
  margin-left: 4px;
  top: 50%;
  transform: translateY(-50%);
}

.hasNumber {
  padding-right: 45px !important;
}

.tab + .tab {
  margin-left: 5px;
}

.noMargin .tab {
  margin-left: 0px !important;
}

.tab.error {
  color: #dc2626;
}

.active {
  cursor: initial;
  background-color: white;
  padding-top: 12px;
  padding-bottom: 12px;
}

/*@media(max-width: 640px){
  .CardTabs{
    display: block;
  }

  .CardTabs span {
    margin-left: unset !important;
    margin-right: unset !important;
    width: 100%;
    margin-bottom: 10px;
  }
}*/
</style>
